import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import * as echarts from 'echarts';
import { error } from 'highcharts';
import { Config } from 'src/app/app-constant';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { PmsYearService } from 'src/app/services/pms-year.service';
import { createChart, createChartForIteration, createChartSingle, formatDate, formatYear } from 'src/app/shared/commen-function-file';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

interface Month {
  key: number;
  name: string;
}
@Component({
  selector: 'app-attrition-demographic',
  templateUrl: './attrition-demographic.component.html',
  styleUrls: ['./attrition-demographic.component.scss'],
})
export class AttritionDemographicComponent implements OnInit {

  openingCount: any;
  closingCount: any;
  attritionCount: any;
  attritionPercentage: any;
  loggedInUserCompanyID: any;
  selectedYearForCompetency: any = null;
  selectedYear: any = null;
  isUserEmployee: boolean = false;
  graphType: string = 'bar';  // Default chart type
  pmsYears: any = [];
  loggedInCompanyFiscalyear: any;
  setupGradeBrand: any;
  setUpyearRange: any;
  loggedInUserEmpCode: any | null;
  buttonColorName: any | null;
  subModuleButtonColor: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  selectedMonth: any;
  fromDateYtdTable: any;
  getMonthsByFiscalandReviewCycle: any = [];
  fromYear: any;
  toYear: any;
  month: any;
  currentMonthIndex: any;
  allMonth: any;
  selectedMonthIndex: any;
  avgAttritedEmpAge: any;
  arrAllMonths: any = [];
  avgAttritionTimeInCompany: any;
  attritionOpeningClosingPercentage: any;
  attrition12Month: any;
  attritionMonth: any;
  previousMonthsCountAprilMarch: any;
  previousMonthsCountJanDec: any;
  attritionMonthAprilMarch: any;
  attritionMonthJanDec: any;
  attrition12MonthAprilMarch: any;
  attrition12MonthJanDec: any;
  echartsOptions: any = {};
  exitedMaleEmployees: any[] = []; // Store only male employees
  exitedFemaleEmployees: any[] = []; // Store only female employees
  exitedMaleCount: number = 0; // Count of exited male employees
  exitedFemaleCount: number = 0; // Count of exited female employees
  maleExitedData: number[] = [];
  femaleExitedData: number[] = [];
  ageGroupBuckets: any = [];
  ageXAxisLabels: any = [];
  getMonthsByFiscalandReviewCycleForReport: any[] = []
  selectedYearReviewCycle: any;
  selectedReviewCycle: any[] = [];
  totalEmployeesData: any = { male: {}, female: {} }; // Store total employees data
  attritionMonthJanDecMale: any;
  proratedAttritionMale: any;
  attritionMonthJanDecFemale: any;
  proratedAttritionFemale: any;


  maleFemaleAttritionData: any;
  totalMaleEmployees: any;
  totalFemaleEmployees: any;
  exitsFemaleCount: any;
  exitsMaleCount: any;
  attritionMonthAprilMarchMale: any;
  attritionMonthAprilMarchFemale: any;

  isRepairedByAssetIcon: any = 'bar';
  isRepairedByAssetTable: boolean = false;
  selectGraphTwoType: any = 'bar';
  isAsseTableGraphTwo: any = [];
  selectedYearForAsset2: any;
  arrHODByUserList: any = [];
  arrUserIds: any = [];
  intHODempCode: any;
  arrHODByExitedUserList: any = [];
  arrExitedUserIds: any = [];

  constructor(private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config,
    public sharedService: SharedService,
    private PmsYearService: PmsYearService,
    private PdfDownload: PdfDownloadService,
    private dataRefreshService: DataRefreshService,

  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    // console.log('loggedInUserCompanyID Value:', this.loggedInUserCompanyID); // Debugging

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.intHODempCode = sessionStorage.getItem('empCode');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    // this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    console.log(this.loggedInUserRole, this.loggedInUserRole);


    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.dataRefreshService.refreshNeeded$.subscribe(() => {
      this.getpmsyearlist();
    });
    this.getpmsyearlist();
  }

  switchGraphType(type: string) {
    this.graphType = type;
  }

  downloadGraph() {
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      // this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      this.pmsYears = formatYear(data?.data?.yearRanges, this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);



    });
  }


  selectedYearForCompetency1: any;
  selectedYearForCompetency2: any;
  selectedYearForCompetency3: any;
  selectedYearForCompetency4: any;
  selectedYearForCompetency5: any;
  selectedYearForCompetency6: any;
  selectedYearForCompetency7: any;
  selectedYearForCompetency8: any;

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency1 = selectedYearObj?.year;
      this.selectedYearForCompetency2 = selectedYearObj?.year;
      this.selectedYearForCompetency3 = selectedYearObj?.year;
      this.selectedYearForCompetency4 = selectedYearObj?.year;
      this.selectedYearForCompetency5 = selectedYearObj?.year;
      this.selectedYearForCompetency6 = selectedYearObj?.year;
      this.selectedYearForCompetency7 = selectedYearObj?.year;
      this.selectedYearForCompetency8 = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      if (this.intHODempCode != 'null') {
        console.log("setSelectedYear for HOD");

        this.fetchHODByUserList('');
      } else {
        console.log("setSelectedYear for super admin");

        // this.getMonths(this.fromYear, this.toYear);
        this.getMonths(this.fromYear, this.toYear, 'first');
        this.getMonths(this.fromYear, this.toYear, 'second');
        this.getMonths(this.fromYear, this.toYear, 'three');
        this.getMonths(this.fromYear, this.toYear, 'four');
        this.getMonths(this.fromYear, this.toYear, 'five');
        this.getMonths(this.fromYear, this.toYear, 'six');
        this.getMonths(this.fromYear, this.toYear, 'seven');
        this.getMonths(this.fromYear, this.toYear, 'eight');
      }

    }
  }

  onYearChange(year: any, graphNo: any) {
    this.taskFromDate = null;
    this.taskToDate = null;

    if (graphNo == 'first') {
      this.selectedYearForCompetency1 = year;
      this.selectedYearForCompetency2 = year;
      this.selectedYearForCompetency3 = year;
      this.selectedYearForCompetency4 = year;
      this.selectedYearForCompetency5 = year;
      this.selectedYearForCompetency6 = year;
      this.selectedYearForCompetency7 = year;
      this.selectedYearForCompetency8 = year;
    }
    if (graphNo == 'second') {
      this.selectedYearForCompetency2 = year;
    }
    if (graphNo == 'three') {
      this.selectedYearForCompetency3 = year;
    }
    if (graphNo == 'four') {
      this.selectedYearForCompetency4 = year;
    }
    else if (graphNo == 'five') {
      this.selectedYearForCompetency5 = year;
    }
    if (graphNo == 'six') {
      this.selectedYearForCompetency6 = year;
    }
    if (graphNo == 'seven') {
      this.selectedYearForCompetency7 = year;
    }
    else if (graphNo == 'eight') {
      this.selectedYearForCompetency8 = year;
    }
    else {

    }
    if (this.intHODempCode != 'null') {
      this.fetchHODByUserList(graphNo);
    } else {
      this.getMonths(this.fromYear, this.toYear, graphNo);
    }
  }

  fetchHODByUserList(graphNo: string) {
    let selectedYear: string;

    switch (graphNo) {
      case 'first':
        selectedYear = this.selectedYearForCompetency1;
        selectedYear = this.selectedYearForCompetency2;
        selectedYear = this.selectedYearForCompetency3;
        selectedYear = this.selectedYearForCompetency4;
        selectedYear = this.selectedYearForCompetency5;
        selectedYear = this.selectedYearForCompetency5;
        selectedYear = this.selectedYearForCompetency7;
        selectedYear = this.selectedYearForCompetency8;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'second':
        selectedYear = this.selectedYearForCompetency2;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'three':
        selectedYear = this.selectedYearForCompetency3;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'four':
        selectedYear = this.selectedYearForCompetency4;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'five':
        selectedYear = this.selectedYearForCompetency5;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'six':
        selectedYear = this.selectedYearForCompetency6;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'seven':
        selectedYear = this.selectedYearForCompetency7;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      case 'eight':
        selectedYear = this.selectedYearForCompetency8;
        this.getMonths(this.fromYear, this.toYear, graphNo);

        break;
      default:
        ['first', 'second', 'three', 'four', 'five', 'six','seven','eight', ''].forEach(gNo => {
          this.getMonths(this.fromYear, this.toYear, gNo);
        });
        selectedYear = this.selectedYearForCompetency1;

    }

    let apiUrl = `${this.config.fetchHODByUserList}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.intHODempCode}&yearRange=${selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`;
    this.httpService.callGetService(apiUrl).subscribe((resp: any) => {
      this.arrUserIds = [];
      const arrHODByUserList = resp?.data?.data?.filter((emp: any) => emp?.userId != this.loggedInUserId);
      this.arrHODByUserList = arrHODByUserList;
      arrHODByUserList?.map((emp: any) => this.arrUserIds.push(emp?.userId));

      // this.getMonths(this.fromYear, this.toYear);
      if (this.loggedInUserRole == 'HOD') {
        // this.fetchKpiScoresForUsers(this.arrUserIds.map(String));
      }
    });

    let url = `${this.config.getEmployeeUnderHodExit}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.intHODempCode}&yearRange=${selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`;

    this.httpService.callGetService(url).subscribe((resp: any) => {
      const arrHODByUserList = resp?.data?.data?.filter((emp: any) => emp?.userId != this.loggedInUserId);
      this.arrHODByExitedUserList = arrHODByUserList;
      arrHODByUserList?.map((emp: any) => this.arrExitedUserIds?.push(emp?.userId));
      // this.fetchNineBoxAttrition();
    });
  }



  fiscalYearMonthsAprilMarch = [
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
  ];

  fiscalYearMonthsJanDec = [
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
  ];


  selectedMonthName: any;

  getMonths(fromYear: any, toYear: any, graphNo: any) {
    this.arrAllMonths = (this.loggedInCompanyFiscalyear === 'Jan_Dec')
      ? this.fiscalYearMonthsJanDec
      : this.fiscalYearMonthsAprilMarch;
    // console.log('arrAllMonths:', this.arrAllMonths);

    const currentMonth = new Date().getMonth() + 1;

    switch (graphNo) {
      case 'first':
        this.selectedMonth1 = currentMonth;
        break;
      case 'second':
        this.selectedMonth2 = currentMonth;
        break;
      case 'three':
        this.selectedMonth3 = currentMonth;
        break;
      case 'four':
        this.selectedMonth4 = currentMonth;
        break;
      case 'five':
        this.selectedMonth5 = currentMonth;
        break;
      case 'six':
        this.selectedMonth6 = currentMonth;
        break;
      case 'seven':
        this.selectedMonth7 = currentMonth;
        break;
      case 'eight':
        this.selectedMonth8 = currentMonth;
        break;
      default:
        this.selectedMonth = currentMonth;
    }

    const selectedMonthObj = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === currentMonth
    );
    this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;

    this.previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === currentMonth) + 1;
    this.previousMonthsCountJanDec = currentMonth;

    switch (graphNo) {
      case 'first':
        this.fetchOpeningCount();
        this.fetchClosingCount();
        this.fetchAttritionCount();
        this.fetchAvgAttritedEmpAge();
        this.fetchAvgAttritionTimeInCompany();
        this.fetchagegroupbucket();
        this.fetchMonthlyAttrition();
        this.fetchDepartmentAttrition();
        this.fetchBandAttrition();
        this.fetchGradeAttrition();
        this.fetchStateAttrition();
        this.fetchFeelingData();
        this.fetchAttritionExitPercentage();
        break;
      case 'second':
        this.fetchagegroupbucket();
        break;
      case 'three':
        this.fetchMonthlyAttrition();
        break;
      case 'four':
        this.fetchDepartmentAttrition();
        break;
      case 'five':
        this.fetchBandAttrition();
        break;
      case 'six':
        this.fetchGradeAttrition();
        break;
      case 'seven':
        this.fetchStateAttrition();
        break;
      case 'eight':
        this.fetchFeelingData();
        break;

      default:
        this.fetchOpeningCount();
        this.fetchClosingCount();
        this.fetchAttritionCount();
        this.fetchAvgAttritedEmpAge();
        this.fetchAvgAttritionTimeInCompany();
        this.fetchagegroupbucket();
        this.fetchMonthlyAttrition();
        this.fetchDepartmentAttrition();
        this.fetchBandAttrition();
        this.fetchGradeAttrition();
        this.fetchStateAttrition();
        this.fetchFeelingData();
        this.fetchAttritionExitPercentage();
    }
  }

  selectedMonth1: any;
  selectedMonth2: any;
  selectedMonth3: any;
  selectedMonth4: any;
  selectedMonth5: any;
  selectedMonth6: any;
  selectedMonth7: any;
  selectedMonth8: any;


  selectedMonthName1: any;
  selectedMonthName2: any;
  selectedMonthName3: any;
  selectedMonthName4: any;
  selectedMonthName5: any;
  selectedMonthName6: any;
  selectedMonthName7: any;
  selectedMonthName8: any;


  previousMonthsCountAprilMarch1: any;
  previousMonthsCountAprilMarch2: any;
  previousMonthsCountAprilMarch3: any;
  previousMonthsCountAprilMarch4: any;
  previousMonthsCountAprilMarch5: any;
  previousMonthsCountAprilMarch6: any;
  previousMonthsCountAprilMarch7: any;
  previousMonthsCountAprilMarch8: any;

  previousMonthsCountJanDec1: any;
  previousMonthsCountJanDec2: any;
  previousMonthsCountJanDec3: any;
  previousMonthsCountJanDec4: any;
  previousMonthsCountJanDec5: any;
  previousMonthsCountJanDec6: any;
  previousMonthsCountJanDec7: any;
  previousMonthsCountJanDec8: any;

  onMonthChange(event: any, graphNo: string) {
    const selectedMonthKey = event.value;

    let selectedMonthName = '';
    let prevCountApril = 0;
    let prevCountJan = 0;

    const selectedMonthObj = this.fiscalYearMonthsJanDec.find(m => m.key === selectedMonthKey);
    selectedMonthName = selectedMonthObj ? selectedMonthObj.name : '';


    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey);
    prevCountApril = indexAprilMarch + 1;

    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === selectedMonthKey);
    prevCountJan = selectedMonthKey;
    // console.log("prevCountJan",prevCountJan,"prevCountApril", prevCountApril)
    switch (graphNo) {
      case 'first':
        this.selectedMonth1 = selectedMonthKey;
        this.selectedMonthName1 = selectedMonthName;
        this.previousMonthsCountAprilMarch1 = prevCountApril;
        this.previousMonthsCountJanDec1 = prevCountJan;
        this.fetchOpeningCount();
        this.fetchClosingCount();
        this.fetchAttritionCount();
        this.fetchAvgAttritedEmpAge();
        this.fetchAvgAttritionTimeInCompany();
        this.fetchAttritionExitPercentage();
        this.selectedMonth2 = selectedMonthKey;
        this.selectedMonthName2 = selectedMonthName;
        this.previousMonthsCountAprilMarch2 = prevCountApril;
        this.previousMonthsCountJanDec2 = prevCountJan;
        this.fetchagegroupbucket();
        this.selectedMonth3 = selectedMonthKey;
        this.selectedMonthName3 = selectedMonthName;
        this.previousMonthsCountAprilMarch3 = prevCountApril;
        this.previousMonthsCountJanDec3 = prevCountJan;
        this.fetchMonthlyAttrition();
        this.selectedMonth4 = selectedMonthKey;
        this.selectedMonthName4 = selectedMonthName;
        this.previousMonthsCountAprilMarch4 = prevCountApril;
        this.previousMonthsCountJanDec4 = prevCountJan;
        this.fetchDepartmentAttrition();
        this.selectedMonth5 = selectedMonthKey;
        this.selectedMonthName5 = selectedMonthName;
        this.previousMonthsCountAprilMarch5 = prevCountApril;
        this.previousMonthsCountJanDec5 = prevCountJan;
        this.fetchBandAttrition();
        this.selectedMonth6 = selectedMonthKey;
        this.selectedMonthName6 = selectedMonthName;
        this.previousMonthsCountAprilMarch6 = prevCountApril;
        this.previousMonthsCountJanDec6 = prevCountJan;
        this.fetchGradeAttrition();
        this.selectedMonth7 = selectedMonthKey;
        this.selectedMonthName7 = selectedMonthName;
        this.previousMonthsCountAprilMarch7 = prevCountApril;
        this.previousMonthsCountJanDec7 = prevCountJan;
        this.fetchStateAttrition();
        this.selectedMonth8 = selectedMonthKey;
        this.selectedMonthName8 = selectedMonthName;
        this.previousMonthsCountAprilMarch8 = prevCountApril;
        this.previousMonthsCountJanDec8 = prevCountJan;
        this.fetchFeelingData();
        break;

      case 'second':
        this.selectedMonth2 = selectedMonthKey;
        this.selectedMonthName2 = selectedMonthName;
        this.previousMonthsCountAprilMarch2 = prevCountApril;
        this.previousMonthsCountJanDec2 = prevCountJan;
        this.fetchagegroupbucket();
        // this.fetchPotentialBuckets();
        break;

      case 'three':
        this.selectedMonth3 = selectedMonthKey;
        this.selectedMonthName3 = selectedMonthName;
        this.previousMonthsCountAprilMarch3 = prevCountApril;
        this.previousMonthsCountJanDec3 = prevCountJan;
        this.fetchMonthlyAttrition();

        break;

      case 'four':
        this.selectedMonth4 = selectedMonthKey;
        this.selectedMonthName4 = selectedMonthName;
        this.previousMonthsCountAprilMarch4 = prevCountApril;
        this.previousMonthsCountJanDec4 = prevCountJan;
        this.fetchDepartmentAttrition();
        break;

      case 'five':
        this.selectedMonth5 = selectedMonthKey;
        this.selectedMonthName5 = selectedMonthName;
        this.previousMonthsCountAprilMarch5 = prevCountApril;
        this.previousMonthsCountJanDec5 = prevCountJan;
        this.fetchBandAttrition();
        break;
      case 'six':
        this.selectedMonth6 = selectedMonthKey;
        this.selectedMonthName6 = selectedMonthName;
        this.previousMonthsCountAprilMarch6 = prevCountApril;
        this.previousMonthsCountJanDec6 = prevCountJan;
        this.fetchGradeAttrition();
        break;
      case 'seven':
        this.selectedMonth7 = selectedMonthKey;
        this.selectedMonthName7 = selectedMonthName;
        this.previousMonthsCountAprilMarch7 = prevCountApril;
        this.previousMonthsCountJanDec7 = prevCountJan;
        this.fetchStateAttrition();
        break;
      case 'eight':
        this.selectedMonth8 = selectedMonthKey;
        this.selectedMonthName8 = selectedMonthName;
        this.previousMonthsCountAprilMarch8 = prevCountApril;
        this.previousMonthsCountJanDec8 = prevCountJan;
        this.fetchFeelingData();
        break;
      default:
        break;
    }
  }


  fetchOpeningCount(): void {
    const month = this.selectedMonth1 || (new Date().getMonth() + 1);
    const userIdsString: string = this.arrUserIds.join(',') || '';

    const apiUrl = (userIdsString) ? `${this.config.openingCountUrl}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency1}&month=${month}&hodUserIds=${userIdsString}` : `${this.config.openingCountUrl}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency1}&month=${month}`;

    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.openingCount = data;
        },
        error: (err) => {
          console.error('Error fetching opening count:', err);
        }
      });
  }

  fetchClosingCount(): void {
    const month = this.selectedMonth1 || (new Date().getMonth() + 1);

    // Call the GET service
    const userIdsString: string = this.arrUserIds.join(',') || '';
    const apiUrl = (userIdsString) ? `${this.config.closingCountUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency1}&month=${month}&hodUserIds=${userIdsString}` : `${this.config.closingCountUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency1}&month=${month}`

    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          // Assuming the API response contains the count in data.data
          this.closingCount = data;
          // console.log('Closing Count:', this.closingCount);
          // this.calculateAttritionPercentage(); // Call function after update

        },
        error: (err) => {
          console.error('Error fetching closing count:', err);
        }
      });
  }
  fetchAttritionCount(): void {
    const month = this.selectedMonth1 || (new Date().getMonth() + 1);

    const userIdsString: string = this.arrExitedUserIds.join(',') || '';
    const apiUrl = (userIdsString) ? `${this.config.attritionCountUrl}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency1}&month=${month}&hodUserIds=${userIdsString}` : `${this.config.attritionCountUrl}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency1}&month=${month}`
    // Call the GET service
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          // Assuming the API response contains the count in data.data
          this.attritionCount = data;
          // console.log('attritionCount:', this.attritionCount);
          // this.calculateAttritionPercentage();
        },
        error: (err) => {
          console.error('Error fetching attritionCount:', err);
        }
      });
  }


  fetchAvgAttritedEmpAge(): void {
    const month = this.selectedMonth1 || (new Date().getMonth() + 1);

    const userIdsString: string = this.arrUserIds.join(',') || '';
    const userExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod

    const apiUrl = (userExitedIdsString) ? `${this.config.AvgAttritedEmpAgeUrl}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency1}&month=${month}&hodUserIds=${userExitedIdsString}` : `${this.config.AvgAttritedEmpAgeUrl}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency1}&month=${month}`
    // Call the GET service
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          console.warn("apiUrl", apiUrl)

          // Assuming the API response contains the count in data.data
          this.avgAttritedEmpAge = data;
          // console.log('AvgAttritedEmpAge:', this.avgAttritedEmpAge);
        },
        error: (err) => {
          console.error('Error fetching avgAttritedEmpAge:', err);
        }
      });
  }
  formattedAttritionTime: any;

  fetchAvgAttritionTimeInCompany(): void {
    const month = this.selectedMonth1 || (new Date().getMonth() + 1);

    const userExitedIdsString = this.arrExitedUserIds.join(',') || '';
    const apiUrl = userExitedIdsString
      ? `${this.config.AvgAttritionTimeInCompanyUrl}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency1}&month=${month}&hodUserIds=${userExitedIdsString}`
      : `${this.config.AvgAttritionTimeInCompanyUrl}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency1}&month=${month}`;

    this.httpService.callGetService(apiUrl).subscribe({
      next: (data: any) => {
        // console.log("Date ---------------", data)
        this.calculateAverageEmploymentDuration(data);
      },
      error: (error) => {
        console.error('Error fetching attrition data:', error);
      }
    });
  }

  avgEmploymentDuration: string = '';
  calculateAverageEmploymentDuration(data: any[]): void {
    if (!Array.isArray(data) || data.length === 0) {
      console.warn('No attrition data available');
      return;
    }

    let totalDays = 0;
    let validCount = 0;

    data.forEach(user => {
      const dojStr = user['date_of_joining']?.trim();
      const dorStr = user['date_of_exit']?.trim() || user['date_of_exit ']?.trim();

      if (!dojStr || !dorStr) return;

      const doj = new Date(dojStr);
      const dor = new Date(dorStr);

      if (isNaN(doj.getTime()) || isNaN(dor.getTime())) {
        console.warn('Invalid date format:', dojStr, dorStr);
        return;
      }

      const days = this.calculateDayDifference(doj, dor);
      totalDays += days;
      validCount++;
    });

    if (validCount === 0) {
      console.warn('No valid records');
      return;
    }
    // console.log(totalDays + "---" + validCount);

    const avgDays = Math.floor(totalDays / validCount);
    const years = Math.floor(avgDays / 365);
    const months = Math.floor((avgDays % 365) / 30); // Rough approximation

    this.avgEmploymentDuration = `${years} year(s), ${months} month(s)`;

    // console.log(`Average Employment Duration: ${this.avgEmploymentDuration}`);
  }

  private calculateDayDifference(startDate: Date, endDate: Date): number {
    const oneDay = 1000 * 60 * 60 * 24; // ms in a day
    const diffInTime = endDate.getTime() - startDate.getTime();
    const diffInDays = Math.floor(diffInTime / oneDay);
    return diffInDays > 0 ? diffInDays : 0;
  }


  fetchAttritionExitPercentage(): void {

    const month = this.selectedMonth1 || (new Date().getMonth() + 1);
    const userIdsString: string = this.arrUserIds.join(',') || '';
    const apiUrl = (userIdsString)
      ? `${this.config.attritionExitPercentageUrl}?companyId=${this.loggedInUserCompanyID}&month=${month}&yearRange=${this.selectedYearForCompetency1}&hodUserIds=${userIdsString}`
      : `${this.config.attritionExitPercentageUrl}?companyId=${this.loggedInUserCompanyID}&month=${month}&yearRange=${this.selectedYearForCompetency1}`

    this.httpService.callGetService(apiUrl).subscribe({
      next: (data: any) => {
        this.attritionPercentage = data;
        console.log('Attrition Exit Percentage:', this.attritionPercentage);
        this.calculateAttritionPercentage();
      },
      error: (err) => {
        console.error('Error fetching Attrition Exit Percentage:', err);
      }
    });
  }

  calculateAttritionPercentage(): void {
    let attritionOpeningClosingPercentage = (this.attritionCount / this.attritionPercentage) * 100;

    this.attritionOpeningClosingPercentage = attritionOpeningClosingPercentage.toFixed(2);
    const month = this.selectedMonth1 || (new Date().getMonth() + 1);
    const selectedMonthKey = month || (new Date().getMonth() + 1);

    const previousMonthsCountJanDec = selectedMonthKey;
    const previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey) + 1;

    if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {

      this.attritionMonthJanDec = (this.attritionOpeningClosingPercentage * 12) / previousMonthsCountJanDec;
      this.attrition12MonthJanDec = this.attritionMonthJanDec.toFixed(2);
      // console.log("Attrition for Jan-Dec:", this.attrition12MonthJanDec);
    }
    else {
      this.attritionMonthAprilMarch = (this.attritionOpeningClosingPercentage * 12) / previousMonthsCountAprilMarch;

      this.attrition12MonthAprilMarch = this.attritionMonthAprilMarch.toFixed(2);
    }
  }

  fetchagegroupbucket(): void {
    this.httpService.callGetService(`${this.config.agegroupbucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency2}`)
      .subscribe({
        next: (data: any) => {
          this.ageGroupBuckets = data;


          // Ensure 'data' property exists and is an array
          if (data?.data && Array.isArray(data.data)) {
            this.ageGroupBuckets = data.data;
          } else {
            console.error("Unexpected API response format for Age Group Buckets:", data);
            this.ageGroupBuckets = [];
          }

          // console.log(" Age Group Buckets:", this.ageGroupBuckets);
          // this.fetchExitedMaleFemaleEmployees();
          this.fetchMaleFemaleAttritionData();
        },
        error: (err) => {
          console.error('Error fetching ageGroupBuckets:', err);
        }
      });
  }



  // Usage for Line Chart
  attritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartForIteration(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }
  // Usage for Bar Chart
  attritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartForIteration(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }


  switchrepaiedAssetGraph(graphType: any) {
    this.selectGraphTwoType = graphType;
    this.isRepairedByAssetIcon = graphType;
    this.isRepairedByAssetTable = false;
    this.ageGroupGraph(this.selectGraphTwoType);

  }

  switchrepaiedAssetGraphForTable() {
    this.selectGraphTwoType = 'table';
    this.isRepairedByAssetIcon = '';
    this.isRepairedByAssetTable = true;

  }
  selectGraphType: any = 'bar';

  selectedFromDated: any;
  selectedtoDated: any;
  taskFromDate: any;
  taskToDate: any;

  formatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }
  processFirstGraphDateRange(): void {
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      fromDate.setHours(0, 0, 0, 0);  // Start of the day
      toDate.setHours(23, 59, 59, 999); // End of the day

      const formattedFromDate = this.formatDateToISO(fromDate) + "T00:00:00";
      const formattedToDate = this.formatDateToISO(toDate) + "T23:59:59";

      this.selectedFromDated = formattedFromDate;
      this.selectedtoDated = formattedToDate;



    } else {
      // console.log('No filtering applied for Graph 1, returning all data');
    }
  }
  downloadChartAsPDF(type: string, graphNo: string): void {
    const chartSelectorMap: { [key: string]: () => string } = {
      'Age Group & Gender': () => this.isRepairedByAssetTable ? 'table-AgeGroup-data' : 'bar-line-exited-chart',
      'Monthly attrition rate': () => this.ismonthlyAttritionRateTable ? 'monthly-data' : 'monthly-attrition-chart',
      'Department-wise Attrition': () => this.isDepartmentAttritionRateTable ? 'table-Department-Attrition-data' : 'department-attrition-chart',
      'Band-wise Attrition': () => this.isBandAttritionRateTable ? 'table-Band-Attrition-data' : 'band-attrition-chart',
      'Grade-wise Attrition': () => this.isGradeAttritionRateTable ? 'table-Grade-Attrition-data' : 'grade-attrition-chart',
      'State-wise Attrition': () => this.isStateAttritionRateTable ? 'table-State-Attrition-data' : 'state-attrition-chart',
      'Feeling Tracker': () => this.isFeelingRateTable ? 'table-Feeling-data' : 'feeling-chart'
    };
  
    const yearMap: { [key: string]: string } = {
      first: this.selectedYearForCompetency1,
      second: this.selectedYearForCompetency2,
      three: this.selectedYearForCompetency3,
      four: this.selectedYearForCompetency4,
      five: this.selectedYearForCompetency5,
      six: this.selectedYearForCompetency6,
      seven: this.selectedYearForCompetency7,
      eight: this.selectedYearForCompetency8
    };
  
    const monthMap: { [key: string]: string } = {
      first: this.selectedMonthName1,
      second: this.selectedMonthName2,
      three: this.selectedMonthName3,
      four: this.selectedMonthName4,
      five: this.selectedMonthName5,
      six: this.selectedMonthName6,
      seven: this.selectedMonthName7,
      eight: this.selectedMonthName8
    };
  
    const idSelector = chartSelectorMap[type]?.() || 'default-chart-id';
  
    const selectedYearRaw = yearMap[graphNo] || this.selectedYearForCompetency1;
    const selectedMonthRaw = monthMap[graphNo] || this.selectedMonthName;
    console.log(selectedMonthRaw, "selectedMonthRaw")
    const selectedYear = this.loggedInCompanyFiscalyear === 'Jan_Dec'
    ? `FY ${selectedYearRaw.split('-')[0]}`
    : `FY ${selectedYearRaw.split('-')[0]}-${selectedYearRaw.split('-')[1]?.slice(-2)}`;

    const normalizedType = type.trim().toLowerCase();
    const excludedTypes = ['monthly attrition rate'];
    const month = excludedTypes.includes(normalizedType) ? '' : selectedMonthRaw;

    // Debug log to verify values if needed
    console.log('Downloading chart with:', {
      idSelector,
      type,
      selectedYear,
      month
    });
  
    this.PdfDownload.downloadPDFMonthwise(idSelector, type, selectedYear, month);
  }
  

  attritionData: any;

  fetchMaleFemaleAttritionData(): void {
    const month = this.selectedMonth2 || (new Date().getMonth() + 1);

    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';

    // Call the GET service
    const apiUrl = (userHodExitedIdsString) ? `${this.config.attritionMaleFemaleDataUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency2}&month=${month}&hodUserIds=${userIdsString}&userHodExitedIds=${userHodExitedIdsString}` : `${this.config.attritionMaleFemaleDataUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency2}&month=${month}`

    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          if (data.status && data.data) {
            this.attritionData = data.data;
            // console.log("attritionData+++++++++++++", this.attritionData,);
            this.ageGroupGraph('bar');

          } else {
            console.error('Invalid response structure:', data);
          }
        },
        error: (err) => {
          console.error('Error fetching male-female attrition data:', err);
        }
      });
  }

  ageGroupGraph(graphType: any) {
    if (!Array.isArray(this.ageGroupBuckets) || !this.ageGroupBuckets.length) {
      console.warn("Data Not Found: Age Group Buckets are missing or invalid");
      this.isAsseTableGraphTwo = [];
      const chartElement = document.getElementById('bar-line-exited-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }
    const month = this.selectedMonth2 || (new Date().getMonth() + 1);
    const selectedMonthKey = month || (new Date().getMonth() + 1);

    const previousMonthsCountJanDec = selectedMonthKey;
    const previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey) + 1;

    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? previousMonthsCountJanDec
        : previousMonthsCountAprilMarch;

    console.log("previousMonthsCount as per loggedInCompanyFiscalyear", previousMonthsCount);


    // Clone buckets and add synthetic last bucket (e.g., 30+)
    const buckets = [...this.ageGroupBuckets];
    const lastBucket = buckets[buckets.length - 1];
    const upperBucket = {
      ageBucketLow: lastBucket.ageBucketMax,
      ageBucketMax: Number.MAX_SAFE_INTEGER // simulate open-ended
    };
    buckets.push(upperBucket);

    const transformedData = buckets.map((bucket: any, index: number) => {
      const isLastBucket = index === buckets.length - 1;
      const ageRange = isLastBucket ? `${bucket.ageBucketLow}+` : `${bucket.ageBucketLow}-${bucket.ageBucketMax}`;

      const filterAges = ([age]: [string, any]) =>
        +age >= bucket.ageBucketLow && (isLastBucket ? true : +age < bucket.ageBucketMax);

      const countUsers = (data: Record<string, any>) =>
        Object.entries(data || {}).filter(filterAges).reduce((count, [, users]) =>
          count + (Array.isArray(users) ? users.length : 0), 0);

      const exitsFemaleCount = countUsers(this.attritionData?.exitsFemale);
      const exitsMaleCount = countUsers(this.attritionData?.exitsMale);
      const femaleCount = countUsers(this.attritionData?.female);
      const maleCount = countUsers(this.attritionData?.male);

      const attritionFemalePercentage = femaleCount > 0 ? +((exitsFemaleCount / femaleCount) * 100).toFixed(2) : 0;
      const attritionMalePercentage = maleCount > 0 ? +((exitsMaleCount / maleCount) * 100).toFixed(2) : 0;
      console.log("previousMonthsCount", previousMonthsCount)
      const annualizedAttritionFemale = (attritionFemalePercentage * 12) / previousMonthsCount;
      const annualizedAttritionMale = (attritionMalePercentage * 12) / previousMonthsCount;

      return {
        xAxisValueData: ageRange,
        seriesValueOneData: exitsMaleCount,
        seriesValueTwoData: exitsFemaleCount,
        maleAttritionPercentage: +attritionMalePercentage.toFixed(2),
        femaleAttritionPercentage: +attritionFemalePercentage.toFixed(2),
        femaleProratedPercentage: +annualizedAttritionFemale.toFixed(2),
        maleProratedPercentage: +annualizedAttritionMale.toFixed(2),
        xAxisName: 'Age Group',
        yAxisName: 'Attrition Count',
      };
    });

    this.isAsseTableGraphTwo = transformedData;

    const graphFunctions: Record<string, Function> = {
      bar: this.attritionBarGraph,
      line: this.attritionLineGraph,
    };

    const renderGraph = graphFunctions[graphType];
    if (renderGraph) {
      renderGraph.call(this, transformedData, 'bar-line-exited-chart', 'double');
    } else {
      console.warn("Invalid graph type specified");
    }
  }

  //--------------------------------Monthly attrition rate------------------------------------------------

  monthlyAttrition: any;

  fetchMonthlyAttrition(): void {
    // console.log( this.loggedInCompanyFiscalyear, "+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++" );
    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';

    const apiUrl = (userHodExitedIdsString) ? `${this.config.attritionMonthlyDataUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.loggedInCompanyFiscalyear}&year=${this.selectedYearForCompetency3}&hodUserIds=${userIdsString}&userHodExitedIds=${userHodExitedIdsString}` : `${this.config.attritionMonthlyDataUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.loggedInCompanyFiscalyear}&year=${this.selectedYearForCompetency3}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.monthlyAttrition = data;
          console.log('Monthly Attrition:', this.monthlyAttrition);
          this.monthlyAttritionGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching monthly attrition:', err);
        }
      });
  }
  ismonthlyAttritionRateIcon: any = 'bar';
  ismonthlyAttritionRateTable: any = false;
  selectGraphMonthlyAttritionType: any = 'bar';
  selectGraphThirdType: any = 'bar';
  isAssetTableGraphFourth: any = []

  // Usage for Line Chart
  monthlyattritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }
  // Usage for Bar Chart
  monthlyattritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }


  monthlyAttritionRate(graphType: any) {
    this.selectGraphMonthlyAttritionType = graphType;
    this.ismonthlyAttritionRateIcon = graphType;
    this.ismonthlyAttritionRateTable = false;
    this.monthlyAttritionGraph(this.selectGraphMonthlyAttritionType);
  }
  monthlyAttritionRateTable() {
    this.selectGraphThirdType = 'table';
    this.ismonthlyAttritionRateIcon = '';
    this.ismonthlyAttritionRateTable = true;
    // this.selectedYearForAsset4 = this.selectedYearForAsset;
  }
  // transformedData: any[] = []; 
  isMonthlyAttritionTableGraph: any = [];
  chartData: any;
  monthlyAttritionData: any;
    // dont remove this code it's month on month 
  // monthlyAttritionGraph(graphType: any) {
  //   // console.log("monthlyAttrition", this.monthlyAttrition);

  //   // if (!this.monthlyAttrition?.data?.length) {
  //   //   console.warn("Data Not Found: Monthly Attrition data is missing");
  //   //   return;
  //   // }

  //   if (!this.monthlyAttrition?.data?.length) {
  //     console.warn("Data Not Found: Monthly Attrition data is missing");
  //     this.isMonthlyAttritionTableGraph = [];
  //     const chartElement = document.getElementById('monthly-attrition-chart') as HTMLDivElement;
  //     if (chartElement) {
  //       echarts.init(chartElement).clear();
  //     }
  //     return;
  //   }

  //   // Determine months order based on fiscal year
  //   const fiscalYearStart = this.loggedInCompanyFiscalyear === "Jan_Dec" ? "01" : "04";

  //   const allMonths = [
  //     { key: "01", name: "January" }, { key: "02", name: "February" },
  //     { key: "03", name: "March" }, { key: "04", name: "April" },
  //     { key: "05", name: "May" }, { key: "06", name: "June" },
  //     { key: "07", name: "July" }, { key: "08", name: "August" },
  //     { key: "09", name: "September" }, { key: "10", name: "October" },
  //     { key: "11", name: "November" }, { key: "12", name: "December" }
  //   ];

  //   const startIndex = allMonths.findIndex(month => month.key === fiscalYearStart);
  //   const monthsOrder = [...allMonths.slice(startIndex), ...allMonths.slice(0, startIndex)];

  //   // Transform Data
  //   const transformedData = monthsOrder.map((monthObj) => {
  //     const monthData = this.monthlyAttrition.data.find((m: any) => m.month === monthObj.key) || {
  //       ActiveUsers: 0,
  //       exitedCount: 0,
  //       month: 0
  //     };

  //     const exitedCount = monthData.exitedCount || 0;
  //     // const Totalmonth = monthData.month
  //     const fiscalMonthIndex = monthsOrder.findIndex(m => m.key === monthObj.key);
  //     const Totalmonth = fiscalMonthIndex + 1; // 1-based index

  //     const cumulativeExitedCount = monthData.cumulativeExitedCount || 0;
  //     const activeUsers = monthData.ActiveUsers || 0;
  //     // const YTDAttrition = activeUsers > 0 ? (cumulativeExitedCount / activeUsers) * 100 : 0;
  //     const YTDAttrition = activeUsers > 0 ? (exitedCount / activeUsers) * 100 : 0;
  //     const previousMonthsCount =
  //       this.loggedInCompanyFiscalyear === "Jan_Dec"
  //         ? this.previousMonthsCountJanDec
  //         : this.previousMonthsCountAprilMarch;
  //     // console.log("Totalmonth", Totalmonth);

  //     const predictedAttrition = (YTDAttrition * 12) / Totalmonth;

  //     return {
  //       xAxisValueData: monthObj.name,
  //       seriesValueTwoData: +YTDAttrition.toFixed(2),
  //       seriesValueOneData: exitedCount,
  //       seriesValueThreeData: +predictedAttrition.toFixed(2),
  //       xAxisName: 'Month',
  //       yAxisName: 'Attrition Count',
  //       seriesLabelTwo: 'Attrition %',
  //       seriesLabelOne: 'Cumulative Exited Count',
  //       seriesLabelThree: 'Annualized Attrition %'
  //     };
  //   });


  //   // console.log("Transformed Monthly Attrition Data:", transformedData);

  //   this.isMonthlyAttritionTableGraph = transformedData;
  //   // **Extract series labels dynamically**
  //   const firstItem = transformedData[0] || {};
  //   const seriesLabels = {
  //     xAxisName: firstItem.xAxisName,
  //     yAxisName: firstItem.yAxisName,
  //     seriesLabelOne: firstItem.seriesLabelOne || 'Series 1',
  //     seriesLabelTwo: firstItem.seriesLabelTwo || 'Series 2',
  //     seriesLabelThree: firstItem.seriesLabelThree || 'Series 3'
  //   };
  //   // **Dynamically render the graph based on graphType**
  //   const graphFunctions: Record<string, Function> = {
  //     bar: this.monthlyattritionBarGraph,
  //     line: this.monthlyattritionLineGraph,
  //   };

  //   const renderGraph = graphFunctions[graphType];
  //   if (renderGraph) {
  //     renderGraph.call(this, transformedData, 'monthly-attrition-chart', 'single', seriesLabels);
  //   }
  // }

  // monthlyAttritionGraph(graphType: any): void {
  //   if (!this.monthlyAttrition?.data?.length) {
  //     console.warn("Data Not Found: Monthly Attrition data is missing");
  //     this.isMonthlyAttritionTableGraph = [];
  //     const chartElement = document.getElementById('monthly-attrition-chart') as HTMLDivElement;
  //     if (chartElement) {
  //       echarts.init(chartElement).clear();
  //     }
  //     return;
  //   }
  
  //   const fiscalYearStart = this.loggedInCompanyFiscalyear === "Jan_Dec" ? "01" : "04";
  //   const allMonths = [
  //     { key: "01", name: "January" }, { key: "02", name: "February" }, { key: "03", name: "March" },
  //     { key: "04", name: "April" }, { key: "05", name: "May" }, { key: "06", name: "June" },
  //     { key: "07", name: "July" }, { key: "08", name: "August" }, { key: "09", name: "September" },
  //     { key: "10", name: "October" }, { key: "11", name: "November" }, { key: "12", name: "December" }
  //   ];
  
  //   const startIndex = allMonths.findIndex(month => month.key === fiscalYearStart);
  //   const monthsOrder = [...allMonths.slice(startIndex), ...allMonths.slice(0, startIndex)];
  
  //   // 🔁 Cumulative exited count logic
  //   let cumulativeExitedCount = 0;
  
  //   const transformedData = monthsOrder.map((monthObj, index) => {
  //     const monthData = this.monthlyAttrition.data.find((m: any) => m.month === monthObj.key) || {
  //       ActiveUsers: 0,
  //       exitedCount: 0,
  //       month: 0
  //     };
  
  //     const exitedCount = monthData.exitedCount || 0;
  //     cumulativeExitedCount += exitedCount;
  
  //     const activeUsers = monthData.ActiveUsers || 0;
  //     const fiscalMonthIndex = index;
  //     const Totalmonth = fiscalMonthIndex + 1;
  
  //     const YTDAttrition = activeUsers > 0 ? (cumulativeExitedCount / activeUsers) * 100 : 0;
  
  //     const previousMonthsCount = this.loggedInCompanyFiscalyear === "Jan_Dec"
  //       ? this.previousMonthsCountJanDec
  //       : this.previousMonthsCountAprilMarch;
  
  //     const predictedAttrition = (YTDAttrition * 12) / Totalmonth;
  
  //     return {
  //       xAxisValueData: monthObj.name,
  //       seriesValueTwoData: +YTDAttrition.toFixed(2),
  //       seriesValueOneData: cumulativeExitedCount, // cumulative exited count
  //       seriesValueThreeData: +predictedAttrition.toFixed(2),
  //       xAxisName: 'Month',
  //       yAxisName: 'Attrition Count',
  //       seriesLabelTwo: 'Attrition %',
  //       seriesLabelOne: 'Cumulative Exited Count',
  //       seriesLabelThree: 'Annualized Attrition %'
  //     };
  //   });
  
  //   this.isMonthlyAttritionTableGraph = transformedData;
  
  //   const firstItem = transformedData[0] || {};
  //   const seriesLabels = {
  //     xAxisName: firstItem.xAxisName,
  //     yAxisName: firstItem.yAxisName,
  //     seriesLabelOne: firstItem.seriesLabelOne || 'Series 1',
  //     seriesLabelTwo: firstItem.seriesLabelTwo || 'Series 2',
  //     seriesLabelThree: firstItem.seriesLabelThree || 'Series 3'
  //   };
  
  //   const graphFunctions: Record<string, Function> = {
  //     bar: this.monthlyattritionBarGraph,
  //     line: this.monthlyattritionLineGraph,
  //   };
  
  //   const renderGraph = graphFunctions[graphType];
  //   if (renderGraph) {
  //     renderGraph.call(this, transformedData, 'monthly-attrition-chart', 'single', seriesLabels);
  //   }
  // }
  monthlyAttritionGraph(graphType: any): void {
    if (!this.monthlyAttrition?.data?.length) {
      console.warn("Data Not Found: Monthly Attrition data is missing");
      this.isMonthlyAttritionTableGraph = [];
      const chartElement = document.getElementById('monthly-attrition-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }
  
    const fiscalYearStart = this.loggedInCompanyFiscalyear === "Jan_Dec" ? "01" : "04";
    const allMonths = [
      { key: "01", name: "January" }, { key: "02", name: "February" }, { key: "03", name: "March" },
      { key: "04", name: "April" }, { key: "05", name: "May" }, { key: "06", name: "June" },
      { key: "07", name: "July" }, { key: "08", name: "August" }, { key: "09", name: "September" },
      { key: "10", name: "October" }, { key: "11", name: "November" }, { key: "12", name: "December" }
    ];
  
    const startIndex = allMonths.findIndex(month => month.key === fiscalYearStart);
    const monthsOrder = [...allMonths.slice(startIndex), ...allMonths.slice(0, startIndex)];
  
    console.log("🗓 Fiscal Month Order:", monthsOrder.map(m => m.name));
  
    // Extract selected fiscal year
    const [selectedStartYearStr] = this.selectedYearForCompetency3?.split('-') || [];
    const selectedStartYear = parseInt(selectedStartYearStr, 10);
  
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
  
    const currentFiscalStartYear = this.loggedInCompanyFiscalyear === "Jan_Dec"
      ? currentYear
      : currentMonth >= 4 ? currentYear : currentYear - 1;
  
    const isCurrentFiscalYear = selectedStartYear === currentFiscalStartYear;
  
    // console.log("🔍 Selected Start Year:", selectedStartYear);
    // console.log("📅 Current Year:", currentYear, "Current Month:", currentMonth);
    // console.log("📊 Is Current Fiscal Year:", isCurrentFiscalYear);
  
    let cumulativeExitedCount = 0;
    const currentFiscalMonthIndex = monthsOrder.findIndex(
      m => m.key === currentMonth.toString().padStart(2, "0")
    );
    const transformedData = monthsOrder.map((monthObj, index) => {
      const monthKey = monthObj.key;
      const isFutureMonth = isCurrentFiscalYear && index > currentFiscalMonthIndex;
    
      let exitedCount = 0;
      let activeUsers = 0;
      let YTDAttrition = 0;
      let predictedAttrition = 0;
    
      if (!isFutureMonth) {
        const monthData = this.monthlyAttrition.data.find((m: any) => m.month === monthKey);
        exitedCount = monthData?.exitedCount || 0;
        activeUsers = monthData?.ActiveUsers || 0;
        cumulativeExitedCount += exitedCount;
    
        YTDAttrition = activeUsers > 0 ? (cumulativeExitedCount / activeUsers) * 100 : 0;
        const Totalmonth = index + 1;
        predictedAttrition = (YTDAttrition * 12) / Totalmonth;
      }
    
      console.log(`📈 ${monthObj.name} | Future: ${isFutureMonth} | Active: ${activeUsers} | Exited: ${exitedCount} | CumExit: ${cumulativeExitedCount} | YTD: ${YTDAttrition.toFixed(2)} | Pred: ${predictedAttrition.toFixed(2)}`);
    
      return {
        xAxisValueData: monthObj.name,
        seriesValueOneData: !isFutureMonth ? cumulativeExitedCount : 0,
        seriesValueTwoData: +YTDAttrition.toFixed(2),
        seriesValueThreeData: +predictedAttrition.toFixed(2),
        xAxisName: 'Month',
        yAxisName: 'Attrition Count',
        seriesLabelOne: 'Cumulative Exited Count',
        seriesLabelTwo: 'Attrition %',
        seriesLabelThree: 'Annualized Attrition %'
      };
    });
    
  
    console.log("✅ Final Transformed Data:", transformedData);
  
    this.isMonthlyAttritionTableGraph = transformedData;
  
    const firstItem = transformedData[0] || {};
    const seriesLabels = {
      xAxisName: firstItem.xAxisName,
      yAxisName: firstItem.yAxisName,
      seriesLabelOne: firstItem.seriesLabelOne || 'Series 1',
      seriesLabelTwo: firstItem.seriesLabelTwo || 'Series 2',
      seriesLabelThree: firstItem.seriesLabelThree || 'Series 3'
    };
  
    const graphFunctions: Record<string, Function> = {
      bar: this.monthlyattritionBarGraph,
      line: this.monthlyattritionLineGraph,
    };
  
    const renderGraph = graphFunctions[graphType];
    if (renderGraph) {
      renderGraph.call(this, transformedData, 'monthly-attrition-chart', 'single', seriesLabels);
    }
  }
  
  
  
  
  
  // --------------------------Dept. Wise-----------------------------
  public isDepartmentAttritionRateIcon: string = 'bar';
  public isDepartmentAttritionRateTable: boolean = false;
  public isDepartmentAttritionTableGraph: any[] = [];
  public selectGraphDepartmentAttritionType: any = 'bar';
  public selectGraphDepartmentType: any = 'bar';
  public isDepartmentTableGraph: any = [];
  public departmentAttrition: any;

  fetchDepartmentAttrition(): void {
    const month = this.selectedMonth4 || (new Date().getMonth() + 1);
    // console.log(this.selectedMonth4, this.selectedMonth1, "----------------------")
    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    const apiUrl = (userHodExitedIdsString) ? `${this.config.attritionDeptDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency4}&month=${month}&userHodExitedIds=${userHodExitedIdsString}` : `${this.config.attritionDeptDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency4}&month=${month}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.departmentAttrition = data;
          // console.log('Department Attrition:', this.departmentAttrition);
          this.departmentAttritionGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching department attrition:', err);
        }
      });
  }

  departmentAttritionRate(graphType: any) {
    this.selectGraphDepartmentAttritionType = graphType;
    this.isDepartmentAttritionRateIcon = graphType;
    this.isDepartmentAttritionRateTable = false;
    this.departmentAttritionGraph(this.selectGraphDepartmentAttritionType);
  }

  departmentAttritionRateTable() {
    this.selectGraphDepartmentType = 'table';
    this.isDepartmentAttritionRateIcon = '';
    this.isDepartmentAttritionRateTable = true;
  }

  departmentAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  departmentAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }
  departmentAttritionGraph(graphType: string): void {
    if (!this.departmentAttrition || !this.departmentAttrition.data?.length) {
      console.error('Data Not Found: Department Attrition data is missing');
      this.isDepartmentAttritionTableGraph = [];
      const chartElement = document.getElementById('department-attrition-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const month = this.selectedMonth4 || (new Date().getMonth() + 1);
    const selectedMonthKey = month || (new Date().getMonth() + 1);

    const previousMonthsCountJanDec = selectedMonthKey;
    const previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey) + 1;

    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? previousMonthsCountJanDec
        : previousMonthsCountAprilMarch;

    console.log("previousMonthsCount as per loggedInCompanyFiscalyear", previousMonthsCount);

    let transformedData: any[] = [];

    const departmentData = this.departmentAttrition.data[0]; // Extract first object

    if (!departmentData) {
      console.error('Invalid department attrition data structure.');
      return;
    }

    const activeUsersMap = new Map<string, number>();
    const exitUsersMap = new Map<string, number>();
    const allExitUsersMap = new Map<string, number>();

    departmentData.AllActiveUsers?.forEach((item: any) => {
      activeUsersMap.set(item.department, item.count);
    });

    departmentData.AllExistsUsers?.forEach((item: any) => {
      exitUsersMap.set(item.department, item.count);
    });

    departmentData.AllExitInBetweenUser?.forEach((item: any) => {
      allExitUsersMap.set(item.department, item.count);
    });

    if (graphType === 'pie') {
      transformedData = departmentData.AllExitInBetweenUser.map((item: any) => {
        const department = item.department;
        const attritionCount = allExitUsersMap.get(department) || 0;
        const activeUserCount = (activeUsersMap.get(department) || 0) - (exitUsersMap.get(department) || 0);
        const attritionPercentage = activeUserCount > 0 ? ((attritionCount / activeUserCount) * 100).toFixed(2) : '0';
        const annualizedAttrition = activeUserCount > 0 ? ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2) : '0';

        return {
          name: department,
          value: attritionCount,
          attritionPercentage,
          annualizedAttrition
        };
      });
    } else {
      transformedData = departmentData.AllExitInBetweenUser.map((item: any) => {
        const department = item.department;
        const attritionCount = allExitUsersMap.get(department) || 0;
        const activeUserCount = (activeUsersMap.get(department) || 0) - (exitUsersMap.get(department) || 0);
        const attritionPercentage = activeUserCount > 0 ? ((attritionCount / activeUserCount) * 100).toFixed(2) : '0';
        const annualizedAttrition = activeUserCount > 0 ? ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2) : '0';

        return {
          xAxisValueData: department,
          seriesValueOneData: attritionCount,
          seriesValueTwoData: +attritionPercentage,
          seriesValueThreeData: +annualizedAttrition,
          xAxisName: 'Department',
          yAxisName: 'Attrition Count',
          seriesLabelOne: 'Attrition Count',
          seriesLabelTwo: 'Attrition %',
          seriesLabelThree: 'Annualized Attrition %'
        };
      });
    }

    // console.log("Transformed Department Attrition Data:", transformedData);
    this.isDepartmentAttritionTableGraph = transformedData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('department-attrition-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'Department',
        yAxisName: 'Attrition Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.departmentAttritionBarGraph,
        line: this.departmentAttritionLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'department-attrition-chart', 'single', seriesLabels);
      }
    }
  }

  attritionPieChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          // console.log(params);

          // Extract all available data dynamically
          let tooltipContent = `<strong>${params.name}</strong><br/>`;
          Object.keys(params.data).forEach((key) => {
            if (key !== 'name' && key !== 'value') {
              const formattedKey = key.replace(/([A-Z])/g, ' $1').trim(); // Convert camelCase to spaced words
              tooltipContent += `${formattedKey}: <strong>${params.data[key]}</strong><br/>`;
            }
          });

          return tooltipContent;
        }
      },
      legend: {
        bottom: 0
      },
      color: [
        '#5470C6', '#91CC75', '#EE6666', '#73C0DE', '#FAC858',
        '#9A60B4', '#EA7CCC', '#3BA${this.loggedInUserCompanyID}', '#FC8452', '#B4A7D6'
      ],
      series: [
        {
          name: 'Department',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            formatter: (params: any) => {
              return `${params.name}: ${params.value}`; // Dynamic label with department & count
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 14,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          data: data
        }
      ],
      xAxis: { show: false },  // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }



  // -------------------Band Wise----------------------------
  public isBandAttritionRateIcon: string = 'bar';
  public isBandAttritionRateTable: boolean = false;
  public isBandAttritionTableGraph: any[] = [];
  public selectGraphBandAttritionType: any = 'bar';
  public selectGraphBandType: any = 'bar';
  public isBandTableGraph: any = [];
  public bandAttrition: any;

  fetchBandAttrition(): void {
    const month = this.selectedMonth5 || (new Date().getMonth() + 1);
    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    const apiUrl = (userHodExitedIdsString) ? `${this.config.attritionBandDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency5}&month=${month}&userHodExitedIds=${userHodExitedIdsString}` : `${this.config.attritionBandDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency5}&month=${month}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.bandAttrition = data;
          // console.log('Band Attrition:', this.bandAttrition);
          this.bandAttritionGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching band attrition:', err);
        }
      });
  }

  bandAttritionRate(graphType: any) {
    this.selectGraphBandAttritionType = graphType;
    this.isBandAttritionRateIcon = graphType;
    this.isBandAttritionRateTable = false;
    this.bandAttritionGraph(this.selectGraphBandAttritionType);
  }

  bandAttritionRateTable() {
    this.selectGraphBandType = 'table';
    this.isBandAttritionRateIcon = '';
    this.isBandAttritionRateTable = true;
  }

  bandAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  bandAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  bandAttritionGraph(graphType: string): void {
    if (!this.bandAttrition || !this.bandAttrition.data?.length) {
      console.error('Data Not Found: Band-wise Attrition data is missing');
      this.isBandAttritionTableGraph = [];
      const chartElement = document.getElementById('band-attrition-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const month = this.selectedMonth5 || (new Date().getMonth() + 1);
    const selectedMonthKey = month || (new Date().getMonth() + 1);

    const previousMonthsCountJanDec = selectedMonthKey;
    const previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey) + 1;

    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? previousMonthsCountJanDec
        : previousMonthsCountAprilMarch;

    console.log("previousMonthsCount as per loggedInCompanyFiscalyear", previousMonthsCount);
    let transformedData: any[] = [];

    const bandData = this.bandAttrition.data[0]; // Extract first object

    if (!bandData) {
      console.error('Invalid band-wise attrition data structure.');
      return;
    }

    const activeUsersMap = new Map<string, number>();
    const exitUsersMap = new Map<string, number>();
    const allExitUsersMap = new Map<string, number>();

    bandData.AllActiveUsers?.forEach((item: any) => {
      activeUsersMap.set(item.band, item.count);
    });

    bandData.AllExistsUsers?.forEach((item: any) => {
      exitUsersMap.set(item.band, item.count);
    });

    bandData.AllExitInBetweenUser?.forEach((item: any) => {
      allExitUsersMap.set(item.band, item.count);
    });

    if (graphType === 'pie') {
      transformedData = bandData.AllExitInBetweenUser.map((item: any) => {
        const band = item.band;
        const attritionCount = allExitUsersMap.get(band) || 0;
        const activeUserCount = (activeUsersMap.get(band) || 0) - (exitUsersMap.get(band) || 0);
        const attritionPercentage = activeUserCount > 0 ? ((attritionCount / activeUserCount) * 100).toFixed(2) : '0';
        const annualizedAttrition = activeUserCount > 0 ? ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2) : '0';

        return {
          name: band,
          value: attritionCount,
          attritionPercentage,
          annualizedAttrition
        };
      });
    } else {
      transformedData = bandData.AllExitInBetweenUser.map((item: any) => {
        const band = item.band;
        const attritionCount = allExitUsersMap.get(band) || 0;
        const activeUserCount = (activeUsersMap.get(band) || 0) - (exitUsersMap.get(band) || 0);
        const attritionPercentage = activeUserCount > 0 ? ((attritionCount / activeUserCount) * 100).toFixed(2) : '0';
        const annualizedAttrition = activeUserCount > 0 ? ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2) : '0';

        return {
          xAxisValueData: band,
          seriesValueOneData: attritionCount,
          seriesValueTwoData: +attritionPercentage,
          seriesValueThreeData: +annualizedAttrition,
          xAxisName: 'Band',
          yAxisName: 'Attrition Count',
          seriesLabelOne: 'Attrition Count',
          seriesLabelTwo: 'Attrition %',
          seriesLabelThree: 'Annualized Attrition %'
        };
      });
    }

    // console.log("Transformed Band-wise Attrition Data:", transformedData);
    this.isBandAttritionTableGraph = transformedData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('band-attrition-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'Band',
        yAxisName: 'Attrition Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.bandAttritionBarGraph,
        line: this.bandAttritionLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'band-attrition-chart', 'single', seriesLabels);
      }
    }
  }
  // -------------------------- Grade Wise -----------------------------
  public isGradeAttritionRateIcon: string = 'bar';
  public isGradeAttritionRateTable: boolean = false;
  public isGradeAttritionTableGraph: any[] = [];
  public selectGraphGradeAttritionType: any = 'bar';
  public selectGraphGradeType: any = 'bar';
  public isGradeTableGraph: any = [];
  public gradeAttrition: any;

  fetchGradeAttrition(): void {

    const month = this.selectedMonth6 || (new Date().getMonth() + 1);
    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    const apiUrl = (userHodExitedIdsString) ? `${this.config.attritionGradeDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency6}&month=${month}&userHodExitedIds=${userHodExitedIdsString}` : `${this.config.attritionGradeDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency6}&month=${month}`

    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.gradeAttrition = data;
          // console.log('Grade Attrition:', this.gradeAttrition);
          this.gradeAttritionGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching grade attrition:', err);
        }
      });
  }

  gradeAttritionRate(graphType: any) {
    this.selectGraphGradeAttritionType = graphType;
    this.isGradeAttritionRateIcon = graphType;
    this.isGradeAttritionRateTable = false;
    this.gradeAttritionGraph(this.selectGraphGradeAttritionType);
  }

  gradeAttritionRateTable() {
    this.selectGraphGradeType = 'table';
    this.isGradeAttritionRateIcon = '';
    this.isGradeAttritionRateTable = true;
  }

  gradeAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  gradeAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  gradeAttritionGraph(graphType: string): void {
    if (!this.gradeAttrition || !this.gradeAttrition.data?.length) {
      console.error('Data Not Found: Grade-wise Attrition data is missing');
      this.isGradeAttritionTableGraph = [];
      const chartElement = document.getElementById('grade-attrition-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const month = this.selectedMonth6 || (new Date().getMonth() + 1);
    const selectedMonthKey = month || (new Date().getMonth() + 1);

    const previousMonthsCountJanDec = selectedMonthKey;
    const previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey) + 1;

    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? previousMonthsCountJanDec
        : previousMonthsCountAprilMarch;

    console.log("previousMonthsCount as per loggedInCompanyFiscalyear", previousMonthsCount);
    let transformedData: any[] = [];

    const gradeData = this.gradeAttrition.data[0]; // Extract first object

    if (!gradeData) {
      console.error('Invalid grade-wise attrition data structure.');
      return;
    }

    const activeUsersMap = new Map<string, number>();
    const exitUsersMap = new Map<string, number>();
    const allExitUsersMap = new Map<string, number>();

    gradeData.AllActiveUsers?.forEach((item: any) => {
      activeUsersMap.set(item.grade, item.count);
    });

    gradeData.AllExistsUsers?.forEach((item: any) => {
      exitUsersMap.set(item.grade, item.count);
    });

    gradeData.AllExitInBetweenUser?.forEach((item: any) => {
      allExitUsersMap.set(item.grade, item.count);
    });

    if (graphType === 'pie') {
      transformedData = gradeData.AllExitInBetweenUser.map((item: any) => {
        const grade = item.grade;
        const attritionCount = allExitUsersMap.get(grade) || 0;
        const activeUserCount = (activeUsersMap.get(grade) || 0) - (exitUsersMap.get(grade) || 0);
        const attritionPercentage = activeUserCount > 0 ? ((attritionCount / activeUserCount) * 100).toFixed(2) : '0';
        const annualizedAttrition = activeUserCount > 0 ? ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2) : '0';

        return {
          name: grade,
          value: attritionCount,
          attritionPercentage,
          annualizedAttrition
        };
      });
    } else {
      transformedData = gradeData.AllExitInBetweenUser.map((item: any) => {
        const grade = item.grade;
        const attritionCount = allExitUsersMap.get(grade) || 0;
        const activeUserCount = (activeUsersMap.get(grade) || 0) - (exitUsersMap.get(grade) || 0);
        const attritionPercentage = activeUserCount > 0 ? ((attritionCount / activeUserCount) * 100).toFixed(2) : '0';
        const annualizedAttrition = activeUserCount > 0 ? ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2) : '0';

        return {
          xAxisValueData: grade,
          seriesValueOneData: attritionCount,
          seriesValueTwoData: +attritionPercentage,
          seriesValueThreeData: +annualizedAttrition,
          xAxisName: 'Grade',
          yAxisName: 'Attrition Count',
          seriesLabelOne: 'Attrition Count',
          seriesLabelTwo: 'Attrition %',
          seriesLabelThree: 'Annualized Attrition %'
        };
      });

      // **Sort the data in alphabetical order**
      transformedData.sort((a, b) => a.xAxisValueData.localeCompare(b.xAxisValueData));
    }

    // console.log("Transformed Grade-wise Attrition Data:", transformedData);
    this.isGradeAttritionTableGraph = transformedData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('grade-attrition-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'Grade',
        yAxisName: 'Attrition Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.gradeAttritionBarGraph,
        line: this.gradeAttritionLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'grade-attrition-chart', 'single', seriesLabels);
      }
    }
  }

  // -------------------------- State Wise -----------------------------
  public isStateAttritionRateIcon: string = 'bar';
  public isStateAttritionRateTable: boolean = false;
  public isStateAttritionTableGraph: any[] = [];
  public selectGraphStateAttritionType: any = 'bar';
  public selectGraphStateType: any = 'bar';
  public isStateTableGraph: any = [];
  public stateAttrition: any;

  fetchStateAttrition(): void {

    const month = this.selectedMonth7 || (new Date().getMonth() + 1);
    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    const apiUrl = (userHodExitedIdsString)
      ? `${this.config.attritionStateDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency7}&month=${month}&userHodExitedIds=${userHodExitedIdsString}`
      : `${this.config.attritionStateDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency7}&month=${month}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.stateAttrition = data;
          // console.log('State Attrition:', this.stateAttrition);
          this.stateAttritionGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching state attrition:', err);
        }
      });
  }

  stateAttritionRate(graphType: any) {
    this.selectGraphStateAttritionType = graphType;
    this.isStateAttritionRateIcon = graphType;
    this.isStateAttritionRateTable = false;
    this.stateAttritionGraph(this.selectGraphStateAttritionType);
  }

  stateAttritionRateTable() {
    this.selectGraphStateType = 'table';
    this.isStateAttritionRateIcon = '';
    this.isStateAttritionRateTable = true;
  }

  stateAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  stateAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }


  stateAttritionGraph(graphType: string): void {
    if (!this.stateAttrition || !this.stateAttrition.data?.length) {
      console.error('Data Not Found: State-wise Attrition data is missing');
      this.isStateAttritionTableGraph = [];
      const chartElement = document.getElementById('state-attrition-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const month = this.selectedMonth7 || (new Date().getMonth() + 1);
    const selectedMonthKey = month || (new Date().getMonth() + 1);

    const previousMonthsCountJanDec = selectedMonthKey;
    const previousMonthsCountAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === selectedMonthKey) + 1;

    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? previousMonthsCountJanDec
        : previousMonthsCountAprilMarch;

    console.log("previousMonthsCount as per loggedInCompanyFiscalyear", previousMonthsCount);

    let transformedData: any[] = [];

    const stateData = this.stateAttrition.data[0]; // Extract first object

    if (!stateData) {
      console.error('Invalid state-wise attrition data structure.');
      return;
    }

    const activeUsersMap = new Map<string, number>();
    const exitUsersMap = new Map<string, number>();
    const allExitUsersMap = new Map<string, number>();

    stateData.AllActiveUsers?.forEach((item: any) => {
      activeUsersMap.set(item.WorkLocationState, item.count);
    });

    stateData.AllExistsUsers?.forEach((item: any) => {
      exitUsersMap.set(item.WorkLocationState, item.count);
    });

    stateData.AllExitInBetweenUser?.forEach((item: any) => {
      allExitUsersMap.set(item.WorkLocationState, item.count);
    });

    if (graphType === 'pie') {
      transformedData = stateData.AllExitInBetweenUser.map((item: any) => {
        const state = item.WorkLocationState;
        const attritionCount = allExitUsersMap.get(state) || 0;
        const activeUserCount = (activeUsersMap.get(state) || 0) - (exitUsersMap.get(state) || 0);
        const attritionPercentage = activeUserCount > 0 ? ((attritionCount / activeUserCount) * 100).toFixed(2) : '0';
        const annualizedAttrition = activeUserCount > 0 ? ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2) : '0';

        return {
          name: state,
          value: attritionCount,
          attritionPercentage,
          annualizedAttrition
        };
      });
    } else {
      transformedData = stateData.AllExitInBetweenUser.map((item: any) => {
        const state = item.WorkLocationState;
        const attritionCount = allExitUsersMap.get(state) || 0;
        const activeUserCount = (activeUsersMap.get(state) || 0) - (exitUsersMap.get(state) || 0);
        const attritionPercentage = activeUserCount > 0 ? ((attritionCount / activeUserCount) * 100).toFixed(2) : '0';
        const annualizedAttrition = activeUserCount > 0 ? ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2) : '0';

        return {
          xAxisValueData: state,
          seriesValueOneData: attritionCount,
          seriesValueTwoData: +attritionPercentage,
          seriesValueThreeData: +annualizedAttrition,
          xAxisName: 'State',
          yAxisName: 'Attrition Count',
          seriesLabelOne: 'Attrition Count',
          seriesLabelTwo: 'Attrition %',
          seriesLabelThree: 'Annualized Attrition %'
        };
      });
    }

    // console.log("Transformed State-wise Attrition Data:", transformedData);
    this.isStateAttritionTableGraph = transformedData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('state-attrition-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'State',
        yAxisName: 'Attrition Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.stateAttritionBarGraph,
        line: this.stateAttritionLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'state-attrition-chart', 'single', seriesLabels);
      }
    }
  }
  // -------------------------- Feeling Tracker -----------------------------
  public isFeelingRateIcon: string = 'bar';
  public isFeelingRateTable: boolean = false;
  public isFeelingTableGraph: any[] = [];
  public selectGraphFeelingType: any = 'bar';
  public selectGraphFeelingCategory: any = 'bar';
  public isFeelingTableGraphData: any = [];
  public feelingData: any;

  fetchFeelingData(): void {
    const month = this.selectedMonth8 || (new Date().getMonth() + 1);
    const userHodExitedIdsString: string = this.arrExitedUserIds.join(',') || ''; //for hod
    const userIdsString: string = this.arrUserIds.join(',') || '';
    const apiUrl = (userHodExitedIdsString) ?
      `${this.config.feelingDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency8}&month=${month}&userHodExitedIds=${userHodExitedIdsString}`
      : `${this.config.feelingDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency8}&month=${month}`
    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.feelingData = data;
          // console.log('Feeling Data:', this.feelingData);
          this.feelingGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching feeling data:', err);
        }
      });
  }

  feelingRate(graphType: any) {
    this.selectGraphFeelingType = graphType;
    this.isFeelingRateIcon = graphType;
    this.isFeelingRateTable = false;
    this.feelingGraph(this.selectGraphFeelingType);
  }

  feelingRateTable() {
    this.selectGraphFeelingCategory = 'table';
    this.isFeelingRateIcon = '';
    this.isFeelingRateTable = true;
  }

  feelingLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  feelingBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  feelingGraph(graphType: string) {
    // console.log("Feeling Data:", this.feelingData);

    if (!this.feelingData?.data?.length) {
      console.warn("Data Not Found: Feeling data is missing");
      this.isFeelingTableGraph = [];
      const chartElement = document.getElementById('feeling-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const moodLabels: Record<number, string> = {
      0: "Excellent",
      1: "Great",
      2: "Okay",
      3: "Not Great"
    };

    // Initialize mood counts to ensure all moods appear, even if their count is zero
    const moodCountMap: Record<string, number> = {
      "Excellent": 0,
      "Great": 0,
      "Okay": 0,
      "Not Great": 0
    };

    // Sum up mood_count values instead of just counting occurrences
    this.feelingData.data.forEach((feeling: any) => {
      const moodLabel = moodLabels[feeling.mood] || "Unknown";
      moodCountMap[moodLabel] += feeling.mood_count; // Accumulate mood_count
    });

    // Transform data for chart
    const transformedData = Object.entries(moodCountMap).map(([mood, count]) => ({
      xAxisValueData: mood,
      seriesValueOneData: count,
      xAxisName: 'How are you feeling today?',
      yAxisName: 'Mood Count',
      seriesLabelOne: 'Mood Count'
    }));

    // console.log("Transformed Feeling Data:", transformedData);
    this.isFeelingTableGraph = transformedData;

    if (graphType === 'pie') {
      // Create the pie chart options and apply them using ECharts
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('feeling-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'Mood',
        yAxisName: 'Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.feelingBarGraph,
        line: this.feelingLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'feeling-chart', 'single', seriesLabels);
      }
    }
  }



}
interface TransformedDataItem {
  xAxisValueData: string;
  seriesValueOneData: number;
  seriesValueTwoData: number;

}
interface TransformedData extends Array<TransformedDataItem> {
  xAxisName?: string;
  yAxisName?: string;
  seriesLabelOne?: string;
  seriesLabelTwo?: string;
  seriesLabelThree?: string;
  seriesLableExited?: string;
  seriesLableProrated?: string;
  seriesLabelAttrition?: string;

}

